'use client';

import React from 'react';
import './SessionCategory.css';
import DonutChart from './DonutChart';
import GroupSessionIcon from '../../../assets/SessionIcon/group-session-icon.svg';
import OneOnOneSessionIcon from '../../../assets/SessionIcon/one-on-one-session-icon.svg';
import PrimeSessionIcon from '../../../assets/SessionIcon/prime-session-icon.svg';

const SessionCategory = ({ sessionCountByType, totalSessions }) => {
  const oneOnOne = sessionCountByType?.one_on_one ?? 0;
  const group = sessionCountByType?.group ?? 0;
  const prime = sessionCountByType?.prime ?? 0;
  const total = typeof totalSessions === 'number' ? totalSessions : 0;

  const formatLabel = (count, name) => `${name}: ${count}`;

  // Define the data structure for the component
  const data = {
    total,
    categories: [
      {
        name: 'One-On-One',
        count: oneOnOne,
        color: '#8B5CF6',
        icon: OneOnOneSessionIcon,
      },
      {
        name: 'Group',
        count: group,
        color: '#6EE7B7',
        icon: GroupSessionIcon,
      },
      {
        name: 'Prime',
        count: prime,
        color: '#ECB100',
        icon: PrimeSessionIcon,
      },
    ],
  };

  // Create the data object expected by DonutChart
  const sessionCategoryData = {
    total: data.total,
    one_on_one: data.categories[0].count,
    group: data.categories[1].count,
    prime: data.categories[2].count,
  };

  return (
    <div className="session-category-card">
      <h2 className="session-category-title">Session Category</h2>

      <div className="chart-container">
        <DonutChart sessionCategoryData={sessionCategoryData} />
      </div>

      <ul className="session-legend-horizontal">
        {data.categories.map(({ name, count, color, icon }) => (
          <li key={name} className="legend-item">
            <div className="legend-details">
              <img className="legend-icon" src={icon} alt={name} />
              <span className="legend-name">{formatLabel(count, name)}</span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SessionCategory;
